import vuexStore from "@/store/customSaveStore";

export const dataAccessAndRestriction = vuexStore({
  namespaced: true,
  path: "/data-access-and-restriction",
  state: {
    editedData: null,
    editedAccessAndRestriction: null,
  },
  getters: {
    editedData: (state) => state.editedData,
    editedAccessAndRestriction: (state) => state.editedAccessAndRestriction,
  },
  mutations: {
    editedData: (state, value) => (state.editedData = value),
    editedAccessAndRestriction: (state, value) => (state.editedAccessAndRestriction = value),
  },
  actions: {
    async resetForm({ commit }) {
      commit("editedAccessAndRestriction", null);
      commit("editedData", null);
    },
  },
});

export const organizationDataAccessor = vuexStore({
  namespaced: true,
  path: "/data-accessor",
});
